import { Button } from "@mui/material";
import { Box } from "@mui/system";
import SearchIcon from '@mui/icons-material/Search';

interface IProps {
  handleSearch: () => void;
  handleClearSearch: () => void;
  disableCancel?: boolean;
}

export default function TableFilterAcionts({
  handleSearch,
  handleClearSearch,
}: IProps) {
  return (
    <Box
      sx={{
        p: 3, gap: 1,
        paddingInlineEnd: "0px",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={handleSearch}
        startIcon={<SearchIcon />}
      >
        Search
      </Button>
      <Button
        variant="outlined"
        color="error"
        onClick={handleClearSearch}
      >
        Clear
      </Button>
    </Box>
  );
}
